import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import * as CONSTANTS from '../constants';
import TEXT from '../text';
import { post } from '../utils/apiUtils';
import * as UTILS from '../utils/utilFunctions';
import withUser from '../utils/withUser';
import CounterPartTable from './CounterPartTable';

class CounterPart extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      counterPartList: []
    };
  }

  getCounterPartListByMarkListId = markListId => {
    this.props.liftUpStateToApp({ showLoadingIndicatorGlobal: true });

    post(CONSTANTS.getCounterPartListByMarkListIdURL, {
      markListId
    })
      .then(resBody => {
        if (resBody) {
          this.setState({
            counterPartList: resBody
          });
        }
      })
      .catch(() => {
        this.props.handleSnackbarOpen(TEXT.lienetApplicant.errors.getMany);
      })
      .finally(() => {
        this.props.liftUpStateToApp({ showLoadingIndicatorGlobal: false });
      });
  };

  handleOnClickCounterPart = (counterPartId, companyId) => {
    this.props.history.push(`/companies?id=${companyId}`);
  };

  componentDidMount() {
    document.title = `Ansprechpartner - ${UTILS.getTitle()}`;
    const markListIdFromParams = UTILS.getURLParam(this.props.history, 'mid');
    this.getCounterPartListByMarkListId(markListIdFromParams);
  }

  render() {
    console.log('counterPartList', this.state.counterPartList);

    return (
      <div className="container-fluid d-flex flex-column">
        <CounterPartTable
          counterPartList={this.state.counterPartList}
          onCounterPartClick={this.handleOnClickCounterPart}
          handleSnackbarOpen={this.props.handleSnackbarOpen}
        />
      </div>
    );
  }
}

CounterPart.propTypes = {
  liftUpStateToApp: PropTypes.func.isRequired,
  handleSnackbarOpen: PropTypes.func.isRequired,
  history: PropTypes.any.isRequired
};

export default withUser(CounterPart);
